
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  addAppointmentTime,
  charge,
  diyContent,
  expedited,
  getOrderServiceProgressList,
} from "@/api/orderService";
import {
  getProgressList
} from "@/api/order";
import { UserModule } from "@/store/modules/user";
import { ModuleType, Type, ViewType } from "@/types/permissionType";
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionUseAndCompany,
  checkServerAppointmentTime,
  checkServerAppointmentTimeIsMust,
  getModelPermission,
  checkPermissionCompany,
} from "@/utils/permission";
import { limit } from "@/types/limit";
import {
  addImage,
  addPrice,
  addRemark,
  addVideo,
  addWord,
  deleteDevice,
  deleteFault,
  deleteImage,
  deleteParts,
  deletePrice,
  deleteProduct,
  deleteRemark,
  deleteTags,
  deleteVideo,
  deleteWord,
} from "@/api/order";
import { addNum, isEmpty, mulNum } from "@/utils";
import { imageType } from "@/types/imageType";
import { makeKey } from "@/utils/qiniu";
import { remarkType } from "@/types/remarkType";
import { getPrice } from "@/api/other";
import { enquiryPass, getTaskEnquiry } from "@/api/orderTaskEnquiry";
import { bottomBtnOrderState, isFinish } from "@/utils/orderStatsUtils";

import DialogImgLarge from "@/components/ImgLarge/index.vue";
import OrderTag from "@/views/order/components/OrderTag.vue";
import SelectFaultDialog from "@/components/SelectFaultDialog/index.vue";
import InputDialog from "@/components/InputDialog/InputDialog.vue";
import supplementProgressDialog from "@/components/SupplementProgressDialog/index.vue";
import OrderDevice from "@/components/DeviceSelectDialog/index.vue";
import SelectParts from "@/views/order/components/OrderParts.vue";
import OrderBrand from "@/views/order/components/OrderBrand.vue";
import DialogDeviceRecord from "@/views/device/components/DeviceRecord.vue";
import EvaluateInfo from '@/components/OrderInfo/EvaluateInfo.vue'

@Component({
  name: "OrderServiceInfo",
  components: {
    DialogImgLarge,
    OrderTag,
    SelectFaultDialog,
    InputDialog,
    OrderBrand,
    SelectParts,
    OrderDevice,
    supplementProgressDialog,
    DialogDeviceRecord,
    EvaluateInfo
  },
  filters: {
    getOrderServiceDealType(value: any) {
      switch (parseInt(value)) {
        case 1:
          value = "派给自己";
          break;
        case 2:
          value = "指派";
          break;
        case 3:
          value = "转单";
          break;
        default:
          value = "未处理";
          break;
      }
      return value;
    },
    getOrderTaskDealType(value: any) {
      switch (parseInt(value)) {
        case 1:
          value = "远程";
          break;
        case 2:
          value = "上门";
          break;
        case 3:
          value = "寄送";
          break;
          case 4:
          value = "转单";
          break;
          case 5:
          value = "送修";
          break;
        default:
          value = "未处理";
          break;
      }
      return value;
    },
    getArraignmentState(value: any) {
      switch (parseInt(value)) {
        case 0:
          value = "未处理";
          break;
        case 1:
          value = "审批通过";
          break;
        case 3:
          value = "审批不通过";
          break;
        case 5:
          value = "审批关闭";
          break;
      }
      return value;
    },
  },
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  confirmButton!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  isDetail!: any;
  @Prop({
    type: Boolean,
    default: true,
  })
  isShowDeal!: any;

  @Prop({
    type: String,
    default: "infor",
  })
  tabName!: any;

  @Prop({
    type: Object,
    default: () => ({
      order: {},
      order_service: {},
    }),
  })
  orderDetail!: any;
  @Prop({
    type: Number,
    default: 21,
  })
  OrderType!: any;

  @Prop({
    type: Boolean,
    default: false,
  })
  isDrawer!: any;
  private totleParts = 0;
  private totlePrice = 0;
  private isShowDeviceHistry: any=false;
  private getSummariesParts(param: any) {
    const { columns, data } = param;
    const sums: any = [];
    let realIndex = 0;
    if (this.formInformation.parts && this.formInformation.parts.length > 0) {
      columns.forEach((column: any, index: any) => {
        if (index === 0) {
          sums[index] = "备件总金额（合计：";
          return;
        }
        const values = data.map((item: any) => Number(item[column.property]));
        if (column.property === "parts_price") {
          realIndex = index;
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return addNum(prev,curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseFloat(sums[index]).toFixed(2);
        }
        this.totleParts = sums[realIndex];
        sums[0] = "备件总金额（合计：" + sums[realIndex] + " 元）";
      });
    } else {
      this.totleParts = 0;
      sums[0] = "备件总金额（合计：" + 0 + " 元）";
    }
    return sums;
  }
  @Watch("formInformation.parts", {
    deep: true,
    immediate: true,
  })
  summaryParts() {
    if (this.formInformation.parts && this.formInformation.parts.length > 0) {
      this.$nextTick(() => {
        const tds: any = document.querySelectorAll(
          "#table-parts .el-table__footer-wrapper tr>td"
        );
        if (tds && tds.length > 0) {
          tds[0].colSpan = 8;
          tds[1].style.display = "none";
          tds[2].style.display = "none";
          tds[3].style.display = "none";
          tds[4].style.display = "none";
          tds[5].style.display = "none";
          tds[6].style.display = "none";
          tds[7].style.display = "none";
        }
      });
    } else {
      this.totleParts = 0;
    }
  }
  private getSummariesPrice(param: any) {
    const { columns, data } = param;
    const sums: any = [];
    let realIndex = 0;
    if (
      this.formInformation.dynamicCost &&
      this.formInformation.dynamicCost.length > 0
    ) {
      columns.forEach((column: any, index: any) => {
        const values = data.map((item: any) => Number(item[column.property]));
        if (column.property === "price_num") {
          realIndex = index;
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return addNum(prev,curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseFloat(sums[index]).toFixed(2);
        }
        this.totlePrice = sums[realIndex];
        sums[0] = "总费用（合计：" + sums[realIndex] + " 元）";
      });
    } else {
      this.totlePrice = 0;
      sums[0] = "总费用（合计：" + 0 + " 元）";
    }
    return sums;
  }
  @Watch("formInformation.dynamicCost", {
    deep: true,
    immediate: true,
  })
  summaryPrice() {
    if (
      this.formInformation.dynamicCost &&
      this.formInformation.dynamicCost.length > 0
    ) {
      this.$nextTick(() => {
        const tds: any = document.querySelectorAll(
          "#table-price .el-table__footer-wrapper tr>td"
        );
        if (tds && tds.length > 0) {
          tds[0].colSpan = 3;
          tds[1].style.display = "none";
          tds[2].style.display = "none";
        }
      });
    } else {
      this.totlePrice = 0;
    }
  }

  @Watch("orderDetail", {
    deep: true,
    immediate: true,
  })
  orderDetailChangeProps() {
    this.$nextTick(() => {
      if (this.activeRight === "schedule") {
        this.getProgressList();
      }
      this.qiniu = this.orderDetail.uptoken;
      this.orderId = this.orderDetail.order.id;
      this.companyId = this.orderDetail.order_service.servicer_company_id;
      if (this.orderDetail.order.parts_list) {
        for (var bean of this.orderDetail.order.parts_list) {
          bean.str =
            this.isNull(bean.parts_name) +
            "/" +
            this.isNull(bean.parts_model_name) +
            "/" +
            this.isNull(bean.parts_amount) +
            "/" +
            this.isNull(bean.parts_unit_price) +
            "/" +
            this.isNull(bean.parts_price) +
            "/" +
            this.isNull(bean.parts_attribute_name);
        }
      }
      if (this.orderDetail.order_service.video_list) {
        for (var bean2 of this.orderDetail.order_service.video_list) {
          bean2.img_url = bean2.full_path;
        }
      }
      this.formInformation.dynamicCost = this.orderDetail.order.order_price;
      this.formInformation.dynamicFault = this.orderDetail.order.fault_list;
      let remack = [];
      if (this.orderDetail.order.order_remark) {
        remack = this.orderDetail.order.order_remark;
      } else {
        remack = [];
      }
      this.formInformation.dynamicRemark = remack;

      // this.evaluate = this.orderDetail.order_service.order_price;

      // 寄修信息
      if (
        this.orderDetail.order_task &&
        this.orderDetail.order_task.order_send
      ) {
        let outsend = {
          type: "1",
          title: "寄出信息",
          name: this.orderDetail.order_task.order_send.send_name,
          mobile: this.orderDetail.order_task.order_send.send_mobile
            ? this.orderDetail.order_task.order_send.send_mobile
            : this.orderDetail.order_task.order_send.send_phone_num,
          address:
            this.orderDetail.order_task.order_send.send_province_name +
            this.orderDetail.order_task.order_send.send_city_name +
            this.orderDetail.order_task.order_send.send_district_name +
            this.orderDetail.order_task.order_send.send_address,
          deliveryName:
            this.orderDetail.order_task.order_send.send_express_name,
          deliveryNumber:
            this.orderDetail.order_task.order_send.send_express_number,
        };
        this.formInformation.dynamicOrderSend.push(outsend);

        let insend = {
          title: "寄回信息",
          name: this.orderDetail.order_task.order_send.reply_name,
          mobile: this.orderDetail.order_task.order_send.reply_mobile
            ? this.orderDetail.order_task.order_send.reply_mobile
            : this.orderDetail.order_task.order_send.reply_phone_num,
          address:
            this.orderDetail.order_task.order_send.reply_province_name +
            this.orderDetail.order_task.order_send.reply_city_name +
            this.orderDetail.order_task.order_send.reply_district_name +
            this.orderDetail.order_task.order_send.reply_address,
          deliveryName:
            this.orderDetail.order_task.order_send.reply_express_name,
          deliveryNumber:
            this.orderDetail.order_task.order_send.reply_express_number,
        };
        this.formInformation.dynamicOrderSend.push(insend);
      } else {
        this.formInformation.dynamicOrderSend = [];
      }
      this.formInformation.tags = this.orderDetail.order.tags;
      this.formInformation.order_check_event_list =
        this.orderDetail.order_check_event_list;
      this.formInformation.brand = this.orderDetail.order_service.brand_list;
      this.formInformation.settle = this.orderDetail.order_service.order_settle;
      this.formInformation.device = this.orderDetail.order_service.device_list;
      this.formInformation.parts = this.orderDetail.order.parts_list;
      this.formInformation.image = this.orderDetail.order.order_image;
      this.formInformation.video = this.orderDetail.order_service.video_list;
      if (this.orderDetail.order_service.document_list) {
        this.formInformation.word =
          this.orderDetail.order_service.document_list;
      } else {
        this.formInformation.word = [];
      }
      if (this.formInformation.word) {
        this.formInformation.word.map(function(item: any) {
          item.name = item.original_name;
        });
      }
      this.formInformation.order_task_list = this.orderDetail.order_task_list;
      if (
        this.orderDetail.order_service.servicer_appointment_timestamp &&
        parseInt(
          this.orderDetail.order_service.servicer_appointment_timestamp
        ) !== 0
      ) {
        this.formInformation.appointment =
          this.orderDetail.order_service.servicer_appointment_timestamp + "000";
      } else {
        this.formInformation.appointment = "";
      }
      this.$set(
        this.formInformation,
        "expedited",
        parseInt(this.orderDetail.order_service.expedited) === 1
      );
      this.$set(
        this.formInformation,
        "isFree",
        parseInt(this.orderDetail.order_service.is_charge) === 1
      );
      this.isTransferOut =
        parseInt(this.orderDetail.order_service.transfer_out) === 1;

      if (!this.isDetail) {
        var dealType = 0;
        this.appointmentTimeVisibility = checkServerAppointmentTime(
          this.orderDetail.order.order_type,
          this.companyId
        );
        this.appointmentTimeMust = checkServerAppointmentTimeIsMust(
          this.orderDetail.order.order_type,
          this.companyId
        );
        if (this.orderDetail.order_task != null) {
          dealType = this.orderDetail.order_task.deal_type;
        }
        this.setPermission(0, this.orderDetail.order.order_type);
      } else {
        this.productModelPermission = { v: 0 };
        this.deviceModelPermission = { v: 0 };
        this.partsModelPermission = { v: 0 };
        this.remarkModelPermission = { v: 0 };
        this.faultModelPermission = { v: 0 };
        this.costModelPermission = { v: 0 };
        this.picModelPermission = { v: 0 };
        this.videoModelPermission = { v: 0 };
        this.tagModelPermission = { v: 0 };
        this.diyOneModelPermission = { v: 0 };
        this.diyTwoModelPermission = { v: 0 };
        this.wordModelPermission = { v: 0 };
        this.appointmentTimeVisibility = false;
        this.appointmentTimeMust = false;
      }
      if(this.OrderType===31&&parseInt(this.orderDetail.order_task.is_assign_enquiry)===1){
      this.handleEnquiry()
    }
    });
  }

  private colors = ["#FFBC29", "#FFBC29", "#FFBC29"];
  private wht = window.innerHeight - 250;
  private activeRight = "infor";
  private orderProgressData: any = {};
  private orderId = "";
  private companyId = "";
  private qiniu: any;
  private qiniuDomain: string = "https://up-z1.qiniup.com";
  private form: object = {};
  private defaultUrl = "";
  private limit: any = limit;
  private isWorksheet = false;
  private orderState = 0;
  private pdficon = require("@/icons/svg/typepdf.svg");

  private isTransferOut: any = false;

  private formInformation: any = {
    appointment: "",
    expedited: false,
    tag: "",
    tags: "",
    brand: "",
    device: "",
    parts: "",
    image: [],
    video: [],
    word: [],

    evaluate: "",

    costType: "",
    costValue: "",
    remark: "",
    order_task_list: [],

    dynamicOrderSend: [],
    dynamicCost: [],
    dynamicFault: [],
    dynamicRemark: [],
  };

  private productModelPermission: any = { v: 0 };
  private deviceModelPermission: any = { v: 0 };
  private partsModelPermission: any = { v: 0 };
  private remarkModelPermission: any = { v: 0 };
  private faultModelPermission: any = { v: 0 };
  private costModelPermission: any = { v: 0 };
  private picModelPermission: any = { v: 0 };
  private videoModelPermission: any = { v: 0 };
  private tagModelPermission: any = { v: 0 };
  private diyOneModelPermission: any = { v: 0 };
  private diyTwoModelPermission: any = { v: 0 };
  private wordModelPermission: any = { v: 0 };
  private appointmentTimeVisibility = false;
  private appointmentTimeMust = false;
  private isShowAddedProgress = false;
  private setPermission(dealType: any, orderType: any) {
    this.orderState = bottomBtnOrderState(
      parseInt(this.orderDetail.order_service.state)
    );
    this.isWorksheet =
      this.orderState >= 3 &&
      checkPermissionCompanyFromOrderType(
        this.orderDetail.order_service.servicer_company_id,
        Type.ORDER_WORK_SHEET,
        this.orderDetail.order.order_type
      );
    this.productModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PRODUCT,
      orderType
    );
    this.deviceModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEVICE,
      orderType
    );
    this.partsModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PARTS,
      orderType
    );
    this.remarkModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_REMARK,
      orderType
    );
    this.diyOneModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_ONE,
      orderType
    );
    this.wordModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_WORD_FILE,
      orderType
    );
    this.diyTwoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_TWO,
      orderType
    );
    this.faultModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_FAULTTYPE,
      orderType
    );
    this.costModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_COST,
      orderType
    );
    this.picModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_IMAGE,
      orderType
    );
    this.videoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_VIDEO,
      orderType
    );
    this.tagModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_TAG,
      orderType
    );
  }

  private setPermissionWithType(
    dealType: any,
    moduleType: ModuleType,
    orderType: any
  ) {
    return getModelPermission(
      this.OrderType === 11
        ? ViewType.DEAL_ORDER
        : this.OrderType === 31
        ? ViewType.DEAL_TASK
        : ViewType.REPORT,
      orderType,
      dealType,
      this.orderDetail.order_service.servicer_company_id,
      moduleType
    );
  }

  created() {
    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
    this.isModifyOtherPrice = parseInt((UserModule.getCompany as any).is_modify_other_price) === 1;
    this.isShowAddedProgress = checkPermissionCompany(UserModule.getCompanyId, Type.TemplateAddedProgressTags);
  }
  private isSelf(userId: any){
    return parseInt(UserModule.getUserId) === parseInt(userId);
  }
  // 报价单--询价单
  private dataTableEnquiry: any = [];
  private handleEnquiry() {
    if (this.OrderType!==31&&parseInt(this.orderDetail.order_service.enquiry_committed_count) < 1) {
      return;
    }
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.user_name = UserModule.getUserName;
    p.company_id = UserModule.getCompanyId;
    p.order_id = this.orderDetail.order.id;
    p.order_service_id = this.orderDetail.order_service.id;
    if(this.OrderType===31){
      p.order_task_id = this.orderDetail.order_task.id;
    }
    getTaskEnquiry(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.dataTableEnquiry = data.list;
        } else {
          this.dataTableEnquiry = [];
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  private getTotalCost(val: any) {
    let part: number = 0;
    let price: number = 0;
    let total: number = 0;
    if (val.part_list) {
      for (let m = 0; m < val.part_list.length; m++) {
        part = addNum(
          part,
          mulNum(
            val.part_list[m].parts_unit_price,
            parseInt(val.part_list[m].parts_amount)
          )
        );
      }
    }
    if (val.price_list) {
      for (let m = 0; m < val.price_list.length; m++) {
        price = addNum(price, val.price_list[m].price_num);
      }
    }
    total = addNum(part, price);
    return total.toFixed(2);
  }
  private getTotalCost1(val:any,val2:any){
    let total = addNum(val, val2);
    return total.toFixed(2);
  }
  private pdfHandle(url: any) {
    window.open(url);
  }
  private enquiryPartsTotal: any = 0;
  private enquiryPriceTotal: any = 0;
  private getEnquiryParts(param: any) {
    const { columns, data } = param;
    if (data && data.length > 0) {
      let currentPrice: Number = 0;
      // for (let t = 0; t < data.length; t++) {
      //   currentPrice += t.parts_unit_price * parseInt(t.parts_amount)
      // }
      currentPrice = data.reduce((prev: any, curr: any) => {

        return addNum(
          prev,
          mulNum(
            curr.parts_unit_price,
            parseInt(curr.parts_amount)
          )
        );
      }, 0);
      this.enquiryPartsTotal = currentPrice.toFixed(2);
    } else {
      this.enquiryPartsTotal = 0.0;
    }

    return [];
  }
  private getEnquiryPrice(param: any) {
    const { columns, data } = param;
    if (data && data.length > 0) {
      let currentPrice: Number = 0;
      currentPrice = data.reduce((prev: any, curr: any) => {
        return addNum(prev,curr.price_num);
      }, 0);
      this.enquiryPriceTotal = currentPrice.toFixed(2);
    } else {
      this.enquiryPriceTotal = 0.0;
    }

    return [];
  }

  private handleServicerClick(tab: any, event: any) {
    switch (tab.name) {
      case "infor":
      case "change":
        this.$emit("referesh", "");
        break;
      case "schedule":
        this.getProgressList();
        break;
    }
  }
  // 加急
  private expeditedCheckbox(val: any) {
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      id: this.orderDetail.order_service.id,
      expedited: val ? "1" : "0",
    };
    expedited(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 安装 是否收费
  private chargeChange(val: any) {
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      order_id: this.orderDetail.order.id,
      order_service_id: this.orderDetail.order_service.id,
      is_charge: val ? "1" : "2",
    };
    if (this.orderDetail.order_task) {
      pamars.order_task_id = this.orderDetail.order_task.id;
    }
    charge(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 标签
  private tagVisible = false;
  private selectTag() {
    if (this.isDetail || this.isTransferOut) {
      return;
    }
    if (parseInt(this.orderDetail.order.order_check_tag_is_pass) === 1) {
      if (this.$refs.inputTag) {
        (this.$refs.inputTag as any).blur();
      }
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: (action) => {},
      });
      return;
    }
    if (
      this.formInformation.tags &&
      this.formInformation.tags.length >= limit.ORDER_SERVICE_ADD_TAG
    ) {
      this.showErrorMsg("您最多选择" + limit.ORDER_SERVICE_ADD_TAG + "个标签");
      return;
    }
    this.tagVisible = true;
  }
  private closeTagHandle(val: boolean) {
    this.tagVisible = val;
  }
  private confirmTagHandle(val: any) {
    this.tagVisible = false;
    this.$emit("referesh", "");
  }
  private handleCloseTags(val: any) {
    if (parseInt(this.orderDetail.order.order_check_tag_is_pass) === 1) {
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: (action) => {},
      });
      return;
    }
    const params: any = {
      tags_id: val.tags_id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteTags(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private faultItemVisibility: any = false;
  private selectFault() {
    if (this.isDetail || this.isTransferOut) {
      return;
    }
    this.faultItemVisibility = true;
  }
  private comfirmSelectFault(val: any) {
    this.faultItemVisibility = val;
    this.$emit("referesh", "");
  }
  private closeSelectFaultDialog(val: any) {
    this.faultItemVisibility = val;
  }

  // 删除故障类型
  private removeFaultHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteFault(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 预约时间
  private appointmentChange(val: any) {
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      order_service_id: this.orderDetail.order_service.id,

      servicer_appointment_time: val / 1000,
    };
    if (this.orderId) {
      pamars.order_id = this.orderId;
    }
    addAppointmentTime(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private getProgressList() {
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.order_service_id = this.orderDetail.order_service.id;
    if (this.orderDetail.order.id) {
      p.order_id = this.orderDetail.order.id;
    }
    p.user_name = UserModule.getUserName;
    let progressRequest ;
    //报修单与其它获取进度调用的接口不一样
    if(this.OrderType === 21){
      progressRequest = getProgressList(p);
    }else{
      progressRequest = getOrderServiceProgressList(p);
    }

    progressRequest.then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });
  }
  // 自定义
  // 添加备注 自定义 弹窗
  private inputDialogVisibility = false;
  private inputDialogEnterType: number = 0;
  private inputDialogContent: string = "";

  private inputDialogComfirmHandle(val: string, val2: any) {
    switch (this.inputDialogEnterType) {
      case 0:
        if (isEmpty(val.trim())) {
          this.showErrorMsg("请填写备注");
          return;
        }
        this.addRemark(val, val2);
        break;
      case 1:
        this.addDiy(val, "diy_one_content");
        break;
      case 2:
        this.addDiy(val, "diy_two_content");
        break;
    }
  }
  private inputDialogClose(val: boolean) {
    this.inputDialogVisibility = val;
  }
  private diyOneAddHandle(val: number) {
    if (val === 1) {
      this.inputDialogContent = this.orderDetail.order.diy_one_content;
    } else {
      this.inputDialogContent = this.orderDetail.order.diy_two_content;
    }
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = val;
  }
  private addDiy(content: string, field: string) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      edit_value: content,
      edit_field: field,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    diyContent(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 备注
  private remarkAddHandle() {
    this.inputDialogContent = "";
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = 0;
  }

  private addRemark(remark: string, val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      remark_type: remarkType.ORDER_SERVICE_DISPOSE,
      remark: remark,
    };
    if (val && val.id) {
      params.classify_id = val.id;
      params.classify_name = val.name;
    }
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private removeRemarkHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 品牌
  private brandVisible = false;
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private closeBrandHandle(val: boolean) {
    this.brandVisible = val;
  }
  private confirmBrandHandle(val: any) {
    this.$emit("referesh", "");
  }
  private deleteBrandHandle(id: any) {
    const params: any = {
      id: id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteProduct(params)
      .then((res: any) => {
        this.showSuccessMsg("删除成功");
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 设备
  private deviceVisible = false;
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }
  private closeDeviceHandle(val: boolean) {
    this.deviceVisible = val;
  }
  private confirmDeviceHandle() {
    this.showSuccessMsg("添加成功");
    this.$emit("referesh", "");
  }
  private deleteDeviceHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteDevice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 设备履历
  private dialogDeviceRecordVisible = false;
  private rowData: any = "";
  private deviceRecordHandle(val: any) {
    this.rowData = val;
    this.dialogDeviceRecordVisible = true;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }
  // 选择别备件
  private partsVisible = false;
  private selectPartsHandle() {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass) === 1) {
      if (this.$refs.inputParts) {
        (this.$refs.inputParts as any).blur();
      }
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: function() {},
      });
      return;
    }
    this.partsVisible = true;
    this.companyId = UserModule.getCompanyId;
  }
  private closeParts(val: boolean) {
    this.partsVisible = val;
  }
  private confirmParts(val: any) {
    this.partsVisible = false;
    this.showSuccessMsg("添加成功");
    this.$emit("referesh", "");
  }
  private deletePartsHandle(val: any) {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass ) === 1) {
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: (action) => {},
      });
      return;
    }
    if (
      val.already_charge_off_num &&
      parseInt(val.already_charge_off_num) !== 0
    ) {
      this.showErrorMsg("备件已核销不能删除");
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加费用
  private costList: any = [];
  private costItemVisibility = false;
  private isModifyOtherPrice = true;
  private priceClick() {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass ) === 1) {
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: (action) => {},
      });
      return;
    }
    this.costItemVisibility = true;
  }
  private selectCost(val: any) {
    this.formInformation.costValue = val.price_num;
  }
  private addCostHandle(type: any, cost: any) {
    if (!type) {
      this.showErrorMsg("请选择费用类型");
      return;
    }
    var temp = {
      price_id: type.id,
      price_name: type.price_name,
      price_num: cost,
    };
    var arr = [];
    arr.push(temp);
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      price: JSON.stringify(arr),
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addPrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.costItemVisibility = false;
        this.formInformation.costValue = "";
        this.formInformation.costType = "";
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private removeCostHandle(v: any) {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass ) === 1) {
      this.$alert("", "此订单已通过审核，不能修改", {
        confirmButtonText: "我知道了",
        center: true,
        callback: (action) => {},
      });
      return;
    }
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deletePrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 获取费用类表
  private getPrice() {
    if (this.costList.length === 0) {
      const params = {
        user_id: UserModule.getUserId,
        company_id: this.companyId,
      };
      getPrice(params)
        .then((res: any) => {
          this.costList = res.data.list;
        })
        .catch((err: any) => {
          let msg = err.msg;
        });
    }
  }
  private workSheetHandle() {
    window.open(
      location.protocol +
        (process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_BASE_API
          : process.env.VUE_APP_BASE_API_DEV) +
        "OrderService/workSheetDetail?company_id=" +
        UserModule.getCompanyId +
        "&user_id=" +
        UserModule.getUserId +
        "&user_name=" +
        UserModule.getUserName +
        "&company_name=" +
        UserModule.getCompanyName +
        "&order_service_id=" +
        this.orderDetail.order_service.id
    );
  }
  private sendOrderToHandle() {
    this.$emit("sendOrderToHandle", "");
  }
  private customerConfirm() {
    this.$emit("customerConfirm", "");
  }
  private isNull(val: any) {
    if (val) {
      return val;
    } else {
      return "~";
    }
  }
  private imgLargeHandle(val: [], index: number, type: number) {
    let arr = [];
    if (type === 10) {
      val.forEach((element: any) => {
        element.img_url = element.full_path;
      });
    }
    if (type === 11) {
      val.forEach((element: any) => {
        element.img_url = element.url;
      });
    }
    if (type === 2) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i]);
      }
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }
  // 图片视频音频文档
  // 上传图片准备
  private beforeUploadUpload(file: any) {
    const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error("上传文件只能是  JPG或PNG 格式!");
    }
    if (!isLt2M) {
      return this.$message.error(
        "上传图片大小不能超过 " + limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + "MB!"
      );
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain,
      };
    });
  }
  private handleUploadSuccess(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      save_path: val.key,
      image_type: imageType.ORDER_SERVICE_IMG_DISPOSE,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(err.msg);
      });
  }
  private deleteImgHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传视频准备
  private beforeUploadUploadVideo(file: any) {
    const isJPG = file.type === "video/mp4";
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error("上传文件只能是  mp4 格式!");
    }
    if (!isLt2M) {
      return this.$message.error(
        "上传视频大小不能超过 " + limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE + "MB!"
      );
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey) + ".mp4";
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain,
      };
    });
  }
  private handleUploadSuccessVideo(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      save_path: val.key,
      video_type: imageType.ORDER_SERVICE_IMG_DISPOSE,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addVideo(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private deleteVideoHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteVideo(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 文档
  private uploadSuccessDocument(res: any, file: any, fileList: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      type: imageType.ORDER_SERVICE_IMG_DISPOSE,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    let arr = [];
    arr.push({
      original_name: file.name,
      save_path: res.key,
    });
    params.document = JSON.stringify(arr);
    addWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private beforeUploadDocument(file: any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain,
      };
    });
  }
  private onExceed() {
    this.$message.error("最多上传4个文档");
  }
  private onRemove(file: any, fileList: any) {
    const params: any = {
      id: file.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("referesh", "");
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private supplementProgressDialogVisible: boolean = false;
  private supplementProgress() {
    this.supplementProgressDialogVisible = true;
  }
  SupplementProgressDialogClose(isRefresh: boolean) {
    this.supplementProgressDialogVisible = false;
    if (isRefresh) {
      this.getProgressList();
    }
  }
  private getName(val: any) {
    let st = val.split("/");
    return st[st.length - 1];
  }
  private getOrderType(orderType: any) {
    let kind = "";
    if (parseInt(orderType) === 1) {
      kind = "其他";
    } else if (parseInt(orderType) === 2) {
      kind = "维保";
    } else if (parseInt(orderType) === 3) {
      kind = "安装";
    } else if (parseInt(orderType) === 4) {
      kind = "巡检";
      if (
        parseInt(this.orderDetail.order_service.polling_check_abnormal_count) >
        0
      ) {
        kind = "巡检" + " 巡异";
      }
    } else {
      kind = "维保";
    }
    return kind;
  }
  private relationDetailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: "/OrderServicer/todetail",
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
      },
    });
    window.open(routeData.href);
  }

  private back() {
    this.$router.go(-1);
  }
  private getPosition(id: any) {
    let currentId: any = document.getElementById(id);
    if (this.isDrawer) {
      currentId.scrollIntoView();
    } else {
      //  chrome
      document.body.scrollTop = currentId.offsetTop + 60;
      //  firefox
      document.documentElement.scrollTop = currentId.offsetTop + 60;
      //  safari
      window.pageYOffset = currentId.offsetTop + 60;
    }
  }
  private getAnwer(answer: any) {
    let str = "";
    if (parseInt(answer.question_type) !== 3) {
      let a = JSON.parse(answer.question_answer);
      for (let index = 0; index < a.length; index++) {
        const element = a[index];
        if (parseInt(element.select) === 1) {
          str = str + element.title + "、";
        }
      }
      str = str.substring(0, str.length - 1);
    } else {
      str = answer.question_answer;
    }

    return str;
  }
  private getEnquiryStr(val: any) {
    //服务单处理
    let str = "";
    if(parseInt(this.OrderType)===11){
      
      switch (parseInt(val)) {
        case 1:
        case 3:
          if(isFinish(this.orderDetail.order_service.state)){
            str = "";
          }else{
            str = "通过";
          }
          break;
        case 5:
          str = "已通过";
          break;
        case 7:
          str = "未通过";
          break;
      }
      
    }else{
      switch (parseInt(val)) {
        case 1:
          str = "未提交";
          break;
        case 3:
          str = "已提交";
          break;
        case 5:
          str = "已通过";
          break;
        case 7:
          str = "未通过";
          break;
      }
    }
    return str;
  }

  private getEnquiryClass(val: any) {
   //服务单处理
   let str = "";
    switch (parseInt(val)) {
      case 1:
        str = "";
        break;
      case 3:
        str = "";
        break;
      case 5:
        str = "font-green";
        break;
      case 7:
        str = "font-red";
        break;
    }
    return str;
  }

  private passEnquiry(row: any) {
    if (parseInt(row.state) === 3&&!isFinish(this.orderDetail.order_service.state)) {
      this.$confirm("确认要通过此询价吗？", "确认通过?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let pamars: any = {
            user_id: UserModule.getUserId,
            user_name: UserModule.getUserName,
            company_id: UserModule.getCompanyId,
            company_name: UserModule.getCompanyName,
            order_id:row.order_id,
            order_service_id:row.order_service_id,
            order_task_id:row.order_task_id,
            enquiry_id:row.id
          };
          enquiryPass(pamars)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.handleEnquiry()
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        })
        .catch(() => {});
    }
  }

  // 自定义评价
  private editEvaluateHandle() {
    let link = this.$router.resolve({
      path: "/order/evaluateOrder",
        query: { evaluateData: JSON.stringify(this.orderDetail),isModify:'1' },
    });
    window.open(link.href);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
